import jsPDF from 'jspdf';
import dayjs from 'dayjs';

export function generateSubSchedule(item, date, periods, matchingPeriods) {
  const doc = new jsPDF({ unit: 'px', format: 'letter' });
  const margin = 20;
  const pageWidth = doc.internal.pageSize.width - margin * 2;
  const pageHeight = doc.internal.pageSize.height;
  let y = margin;

    // HEADER
    y += 10;
    const circleX = margin + 25; // X position for the circle
    const circleY = y + 25; // Y position for the circle
    const circleRadius = 25; // Radius of the circle
  
    // Draw the circle with an orange background
    doc.setFillColor(255, 165, 0); // Orange color
    doc.circle(circleX, circleY, circleRadius, 'F'); // Fill the circle
  
    // Set the text "iLS" in bold
    doc.setFontSize(26);
    doc.setTextColor(255);
    doc.setFont("helvetica", "bold");
    doc.text("iLS", circleX, circleY + 7, { align: "center" });
  
    doc.setFont("helvetica", "undefined"); 
    doc.setTextColor(0);

    const titleX = circleX + circleRadius * 2 - 10;
    doc.setFontSize(16);
    const titleLines = [`${item.substituteName}'s Schedule for ${dayjs(date).format('ddd - MMMM DD, YYYY')}`];
    doc.text(titleLines, titleX, circleY); 
  
    y = circleY + 10; 
    doc.setFontSize(12);
    doc.text(`Total Periods: ${item.count}`, titleX, y);

    y += 20

  // Table Header
  const tableMargin = 10;
  const tableWidth = pageWidth - 2 * tableMargin;
  const columnWidth = tableWidth / 2; // Two columns
  const rowHeight = 30;

  // Table headers
  doc.setFontSize(12);
  doc.setFillColor(240, 240, 240);
  doc.rect(margin, y, tableWidth, rowHeight, 'F');
  doc.setTextColor(0);
  doc.text("Period", margin + 5, y + 20);
  doc.text("Course Name", margin + columnWidth + 5, y + 20);
  
  y += rowHeight;

  // Period & Course Names
  periods.forEach((period) => {
    doc.setFillColor(255, 255, 255);
    doc.rect(margin, y, tableWidth, rowHeight, 'F');

    doc.setTextColor(0);
    doc.text(period.name, margin + 5, y + 20);

    const matchingCourse = matchingPeriods.find(matching => matching.id === period.id);
    const courseName = matchingCourse ? matchingCourse.courseSessionName : '-';
    doc.text(courseName, margin + columnWidth + 5, y + 20);

    y += rowHeight;
  });

  // Footer
  y = pageHeight - 20;
  doc.setFontSize(8);
  doc.setTextColor(150);
  doc.text(
    `Generated on ${dayjs().format('MMMM DD, YYYY h:mm A')}`,
    margin,
    y
  );

  const pdfBlob = doc.output('blob');
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, '_blank');
}
